import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useEntitlementCard = (staffId, type = "") => {
  return useQuery({
    queryKey: ["entitlementCardState", staffId, type],
    queryFn: async () =>
      callApi({
        path: "entitlement",
        command: type,
        data: JSON.stringify({
          list: { filter: { staffId: staffId } },
        }),
      }),
  });
};
